import bootbox from 'bootbox'
import $ from 'jquery'

class Shout {

    createToast (message = '', opts) {

        var options = {
            delay: 2000,
            type: 'success',
            title: 'Ping pong',
            iconClass: 'fas fa-check',
            wrapper: {
                position: 'fixed',
                top: 10,
                right: 10,
                zIndex: 99999,
                minWidth: 300
            },
            ...opts
        }

        const toastWrapper = document.createElement('div')
        toastWrapper.setAttribute('class', 'toast')
        toastWrapper.style.position = options.wrapper.position
        toastWrapper.style.top = options.wrapper.top + 'px'
        toastWrapper.style.right = options.wrapper.right + 'px'
        toastWrapper.style.zIndex = options.wrapper.zIndex
        toastWrapper.style.minWidth = options.wrapper.minWidth + 'px'

        toastWrapper.setAttribute('data-delay', options.delay)
        toastWrapper.setAttribute('role', 'alert')
        toastWrapper.setAttribute('aria-alive', 'assertive')
        toastWrapper.setAttribute('aria-atomic', 'true')

        const toastHeader = document.createElement('div')
        toastHeader.setAttribute('class', 'toast-header')

        const title = document.createElement('strong')
        title.setAttribute('class', 'mr-auto')
        const icon = `<i class="${options.iconClass}"></i> `
        title.innerHTML = icon + options.title

        const closeButton = document.createElement('button')
        closeButton.setAttribute('type', 'button')
        closeButton.setAttribute('class', 'ml-2 mb-1 close')
        closeButton.setAttribute('data-dismiss', 'toast')
        closeButton.setAttribute('aria-label', 'Close')

        const closeSign = document.createElement('span')
        closeSign.setAttribute('aria-hidden', 'true')
        closeSign.innerHTML = '&times;'

        closeButton.appendChild(closeSign)

        if (options.type === 'success') {
            toastHeader.classList.add('bg-success')
        }

        if (options.type === 'warning') {
            toastHeader.classList.add('bg-warning')
        }

        if (options.type === 'error') {
            toastHeader.classList.add('bg-danger')
        }

        toastHeader.appendChild(title)
        toastHeader.appendChild(closeButton)

        const toastBody = document.createElement('div')
        toastBody.setAttribute('class', 'toast-body')
        toastBody.innerHTML = message

        toastWrapper.appendChild(toastHeader)
        toastWrapper.appendChild(toastBody)

        document.body.appendChild(toastWrapper)

        $(toastWrapper).toast('show')
            .on('hidden.bs.toast', () => {
                toastWrapper.remove()
            })
    }
}

export default {
    success: (message) => {
        const shout = new Shout
        shout.createToast(message, {
            title: 'Success'
        })
    },

    warning: (message, options) => {
        const shout = new Shout
        shout.createToast(message, {
            title: 'Warning.',
            type: 'warning',
            iconClass: 'fas fa-info-circle',
            ...options
        })
    },

    error: (message, options) => {
        const shout = new Shout
        shout.createToast(message, {
            title: 'Hmm.. something wrong',
            type: 'error',
            iconClass: 'fas fa-times',
            ...options
        })
    },

    confirm: (message, callback = function () {}) => {
        bootbox.confirm({
            message,
            callback: result => {
                if (result) {
                    return callback()
                }
            }
        })
    }
}
